import React, { useState } from 'react';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { BiGift, BiEdit, BiShareAlt } from 'react-icons/bi';
import { TbBellUp } from "react-icons/tb";
import { authenticatedUserAddress, isUserSignedIn } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/material';
import { GrLock, GrUnlock } from "react-icons/gr";
import CreateChimeModal from '../modal/CreateChimeModal';

const appOrigin = window.location.origin;
const RecipeReviewCard = ({ fileName, title, content, status, created, maxLength = 300, profileAddress,
    setShowGiftingModal,
    setShowWoopsModal,
    setShowUserContractDeployModal,
    userContractStatus,
    setShowAdvisoryModal,
    setErrorMsg,
    setOpenSnackBar,
    originDifference
}) => {
    const [expanded, setExpanded] = useState(false);
    const [showShareAsChime, setShowShareAsChime] = useState(false);

    const authedUser = authenticatedUserAddress({ network: clientNetwork });

    const mdParser = new MarkdownIt();

    const isLongText = String(content).length > maxLength;
    const displayText = isLongText ? String(content).slice(0, maxLength) + '...' : String(content);

    function validate(open, value) {
        switch (userContractStatus) {
            case true:
                open(value);
                break;
            case false:
            case 'success':
            case 'mempool':
            case 'abort_by_post_condition':
            case 'abort_by_response':
                setShowUserContractDeployModal(true);
                break;
            case 'updateNeeded':
                setShowAdvisoryModal(true);
                break;
            default:
                if (isUserSignedIn()) {
                    console.log('fired');
                    setShowUserContractDeployModal(true);
                } else {
                    setShowWoopsModal(true);
                }
                break;
        }
    }

    function redirect(path) { window.location.assign(path); };
    function handleExpandClick() { setExpanded(!expanded); };

    // Function to convert markdown to sanitized HTML
    const createMarkup = (text) => {
        const rawHtml = mdParser.render(text || '');
        const cleanHtml = DOMPurify.sanitize(rawHtml);
        return { __html: cleanHtml };
    };

    function editExhibit() {
        if (isUserSignedIn()) {
            validate(redirect, `${appOrigin}/exhibit/${fileName}`);
        } else {
            setShowWoopsModal(true)
        }
    }

    function giftExhibit() {
        console.log({ hello: userContractStatus });
        validate(setShowGiftingModal, true);
    }

    function copyShareUrl() {
        console.log(fileName);
        if (!fileName) {
            setErrorMsg({ msg: `Exhibit share url Copy error`, reason: 'success' });
            setOpenSnackBar(true);
            return;
        }

        navigator.clipboard.writeText(`${appOrigin}/${profileAddress}/exhibit/${fileName}`);
        setErrorMsg({ msg: `Exhibit share url Copied`, reason: 'success' });
        setOpenSnackBar(true);
    }

    function handleShareAsChime() {
        setShowShareAsChime(true);
    }

    console.log({ userContractStatus });

    return (
        <>
            {content &&
                <Card>
                    <CardHeader
                        // sx={{ display: 'flex' }}
                        title={title}
                        subheader={
                            <Box display="flex" gap={1} alignItems="center">
                                {status === 'Published' ? <GrUnlock sx={{ mr: 3, color: 'white' }} /> : <GrLock sx={{ mr: 3, color: 'white' }} />}
                                <Typography variant="body2" component="span" sx={{ color: 'white' }}>
                                    {'Updated: ' + created}
                                </Typography>
                            </Box>}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                            justifyContent: 'center',
                            backgroundImage: 'linear-gradient(90deg, #f7931a, #6444fe)',
                            maxHeight: '65px',
                            '& .MuiCardHeader-title': {
                                textAlign: 'left', // Align title text to the left
                                width: '100%', // Take full width for alignment
                                maxHeight: '25px',
                                color: 'white',
                            },
                            '& .MuiCardHeader-subheader': {
                                textAlign: 'left', // Align subheader text to the left
                                width: '100%', // Take full width for alignment
                                color: 'white',
                                fontSize: 'small',
                                maxHeight: '10px'
                            },
                        }}
                    />
                    <CardContent sx={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                        <Typography component='div' variant="body2" dangerouslySetInnerHTML={createMarkup(expanded ? content : displayText)} />
                        {isLongText && (<code onClick={handleExpandClick} style={{ cursor: 'pointer', color: '#f7931a' }} size="small">{expanded ? "Show Less" : "Show More"}</code>)}
                    </CardContent>

                    <CardActions
                        sx={{
                            backgroundImage: 'linear-gradient(90deg, #f7931a, #6444fe)',
                            maxHeight: '35px',
                            justifyContent: 'space-evenly'
                        }}
                    >
                        {authedUser === profileAddress && <IconButton disabled={!originDifference} aria-label="edit" onClick={editExhibit}><BiEdit color='white' /></IconButton>}
                        {authedUser !== profileAddress && <IconButton aria-label="gift" onClick={giftExhibit}><BiGift color='white' /></IconButton>}
                        {authedUser === profileAddress && <Tooltip title="Share as Chime (Public or Private)" placement="right"><IconButton aria-label="share" onClick={handleShareAsChime}><TbBellUp color='white' /></IconButton></Tooltip>}
                        <IconButton aria-label="share" onClick={copyShareUrl}><BiShareAlt color='white' /></IconButton>

                    </CardActions>
                </Card >
            }

            {showShareAsChime && <CreateChimeModal show={showShareAsChime} setShow={setShowShareAsChime} close={() => setShowShareAsChime(false)} exhibitAttachment={{ at_url: '', at_file: title, at_name: fileName, at_state: true, type: 'md' }} />}
        </>

    );
}

const ExhibitViewOnly = ({ fileName, title, content, status, created, profileAddress,
    setShowWoopsModal,
    setShowUserContractDeployModal,
    setOpenConfirmModal,
    userContractStatus,
    storageUrl,
    setShowAdvisoryModal,
    setOpenSnackBar,
    setErrorMsg,
    originDifference
}) => {

    return (
        <div className="chime-container">
            <RecipeReviewCard fileName={fileName} title={title} content={content} status={status} created={created} profileAddress={profileAddress}
                setShowWoopsModal={setShowWoopsModal}
                setShowUserContractDeployModal={setShowUserContractDeployModal}
                setOpenConfirmModal={setOpenConfirmModal}
                userContractStatus={userContractStatus}
                storageUrl={storageUrl}
                setShowAdvisoryModal={setShowAdvisoryModal}
                setOpenSnackBar={setOpenSnackBar}
                setErrorMsg={setErrorMsg}
                originDifference={originDifference}
            />
        </div>
    );
};

export default ExhibitViewOnly;